//@ts-nocheck
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { _baseRequest, COMMON } from '../../../utils/baseApi';
import { getColorForLabel } from '../../../utils/colorUtils';
import { format, formatDistanceStrict } from 'date-fns';
import { take } from 'lodash';
import { Divide } from 'lucide-react';
import { ta } from 'date-fns/locale';
import { ExclamationIcon, MeetingIcon, NotebookIcon, ReviewIcon, ScoreCardIcon } from '../../icons/Icons';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'

const InboxDetails = [
    { id: 'all', name: 'All' },
    // { id: 'scorecard', name: 'Scorecard' },
    { id: 'questionnaire', name: 'Questionnaire' },
    { id: 'meeting', name: 'Meeting' },
    { id: 'review', name: 'Review' },
];


function JobActivity() {
    const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string; }>();
    const [allTaskItem, setAllTaskItem] = useState({
        activitys: [],
        totalActivitys: 0,
        currentPage: 1,
        hasNextPage: false,
        limit: 25,
        totalPages: 1
    });
    const [isLoading, setIsLoading] = useState(false);
    const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
    const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selected, setSelected] = useState(InboxDetails[0])
    const navigate = useNavigate()

    const getSenderDetails = (item) => {
        // Default return object
        const defaultDetails = {
            image: null,
            name: null
        };

        // If msg_user_id exists, find in baseMembers
        if (item.user_id) {
            const senderUser = baseMembers.find(member => member.user_id === item.user_id) || {};
            return {
                image: senderUser.profile_pic || null,
                name: senderUser.name || null
            };
        }

        return defaultDetails;
    };


    // const getShortFormTimeAgo = (createdAt) => {
    //   const timeAgo = formatDistanceStrict(new Date(createdAt), new Date(), {
    //     addSuffix: true,
    //     includeSeconds: true,
    //   });

    //   const shortFormTimeAgo = timeAgo
    //     .replace(/ hours?/, ' hrs')
    //     .replace(/ minutes?/, ' mins')
    //     .replace(/ seconds?/, ' secs')
    //     .replace(/ days?/, ' days')
    //     .replace(/ months?/, ' mon')
    //     .replace(/ years?/, ' yrs');

    //   const cleanedTimeAgo = shortFormTimeAgo
    //     .replace(/\sago$/, '')
    //     .replace(/^about\s/, '');

    //   return cleanedTimeAgo;
    // };

    useEffect(() => {
        const fetchInitialData = async () => {
            let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/activity.listActivitys?page=1&limit=${allTaskItem.limit}`;

            // select

            if (jobId) {
                fullUrl += `&job_id=${jobId}`;
            }
            if (applicationId) {
                fullUrl += `&app_id=${applicationId}`;
            }

            if (selected.id === 'scorecard') {
                fullUrl += `&activity_type=scorecard`;
            } else if (selected.id === 'questionnaire') {
                fullUrl += `&activity_type=questionnaire`;
            } else if (selected.id === 'meeting') {
                fullUrl += `&activity_type=meeting`;
            } else if (selected.id === 'review') {
                fullUrl += `&activity_type=review`;
            }
            try {
                setIsLoading(true);
                const response = await _baseRequest(fullUrl, 'GET');

                if (response?.data?.activitys && response?.data?.activitys?.length > 0) {
                    setAllTaskItem(response?.data);
                } else {
                    setAllTaskItem({
                        activitys: [],
                        totalActivitys: 0,
                        currentPage: 1,
                        hasNextPage: false,
                        limit: 25,
                        totalPages: 1
                    });
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (baseId) {
            fetchInitialData();
        }
    }, [baseId, selected]);

    const formatDate = (createdAt) => {
        return format(new Date(createdAt), 'dd MMM yyyy'); // e.g., "28 May 2025"
    };

    const getStatusBadgeClasses = (status) => {
        switch (status) {
            case 'pending':
                return 'bg-yellow-100 text-yellow-700';
            case 'completed':
                return 'bg-green-100 text-green-700';
            case 'overdue':
                return 'bg-red-100 text-red-700';
            default:
                return 'bg-gray-100 text-gray-700';
        }
    };

    const handleLoadMore = async () => {
        if (!allTaskItem.hasNextPage) return;

        const nextPage = allTaskItem.currentPage + 1;
        let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/activity.listActivitys?page=${nextPage}&limit=${allTaskItem.limit}`;

        if (jobId) {
            fullUrl += `&job_id=${jobId}`;
        }

        if (applicationId) {
            fullUrl += `&app_id=${applicationId}`;
        }

        try {
            setIsLoadingMore(true);
            const response = await _baseRequest(fullUrl, 'GET');

            if (response?.data?.activitys && response?.data?.activitys?.length > 0) {
                setAllTaskItem(prev => ({
                    ...response.data,
                    activitys: [...prev.activitys, ...response.data.activitys] // Append new tasks to existing ones
                }));
            }
        } catch (error) {
            console.error("Error loading more data:", error);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const handleSelectionChange = (item) => {
        setSelected(item);
    }

    function classNames(...classes: any) {
        return classes.filter(Boolean).join(' ')
    }

    const handleApplicationDetails = (data) => {
        if (data?.type === 'overview') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/overview`)
        }
        if (data?.type === 'normal') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/overview`)
        }
        if (data?.type === 'resume') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/resume`)
        }
        if (data?.type === 'message') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/message`)
        }
        if (data?.type === 'files') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/files`)
        }
        if (data?.type === 'team-discussion') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/team-discussion`)
        }
        if (data?.type === 'scorecard') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/scorecards`)
        }
        if (data?.type === 'notes') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/notes`)
        }
        if (data?.type === 'questionnaire') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/questionnaire`)
        }
        if (data?.type === 'meeting') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/meetings`)
        }
        if (data?.type === 'review') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/appreview`)
        }
        if (data?.type === 'journey') {
            navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/journey`)
        }
    }

    return (
        <div className="mt-[0px]   py-[0px]">
            <div className="w-full max-w-[710px] mx-auto pb-[50px]">


                <div className="bg-white rounded-lg overflow-hidden border border-solid border-[#0009321f]">

                    {/* Header Row */}
                    <div className="grid grid-cols-10 gap-4 px-6 py-3 bg-[#00005506] border-b border-gray-200">
                        <div className="col-span-8 font-semibold text-[#1c2024] text-sm">Action</div>

                        <div className="col-span-2 font-semibold text-[#1c2024] text-sm">Date</div>
                    </div>

                    {isLoading ? (
                        <div className="flex items-center justify-center h-[calc(100vh_-_380px)] w-full">
                            <div className="simple-spinner-loader">
                                <span></span>
                            </div>
                        </div>
                    ) : !allTaskItem?.activitys?.length ? (
                        <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3' style={{ height: 'calc(100vh - 380px)' }}>
                            <ExclamationIcon />
                            <p className='text-[#0000007a] text-[13px]'>No task found</p>
                        </div>
                    ) : (
                        // Your existing list rendering code
                        allTaskItem.activitys && allTaskItem.activitys.map((task, index) => {
                            const formattedDate = formatDate(task.created_at);

                            const { image, name } = getSenderDetails(task);
                            return (
                                <div key={index} className="grid grid-cols-10 gap-4 px-6 py-4 border-b border-[#0009321f] last-of-type:border-b-0">
                                    <div className='col-span-8'>
                                        <div className='flex items-center gap-x-2 '>
                                            <div className="flex-shrink-0">
                                                {
                                                    task.activity_type === 'stage' && <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="icon icon-tabler icons-tabler-outline icon-tabler-brand-walmart  w-[1rem] h-[1rem] text-[#808080]"
                                                    >
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M12 8.04v-5.04" />
                                                        <path d="M15.5 10l4.5 -2.5" />
                                                        <path d="M15.5 14l4.5 2.5" />
                                                        <path d="M12 15.96v5.04" />
                                                        <path d="M8.5 14l-4.5 2.5" />
                                                        <path d="M8.5 10l-4.5 -2.505" />
                                                    </svg>

                                                }
                                                {/* {
                                                    task.activity_type === 'scorecard' && <ScoreCardIcon />
                                                } */}
                                                {
                                                    task.activity_type === 'questionnaire' && <NotebookIcon />
                                                }
                                                {
                                                    task.activity_type === 'meeting' && <MeetingIcon />
                                                }
                                                {
                                                    task.activity_type === 'review' && <ReviewIcon />
                                                }
                                                {
                                                    task.activity_type === 'normal' &&
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="icon icon-tabler icons-tabler-outline icon-tabler-brand-asana  w-[1rem] h-[1rem] text-[#808080]"
                                                    >
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                                        <path d="M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                                        <path d="M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                                    </svg>

                                                }

                                            </div>
                                            <p className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-1 ">{task.message}</p>
                                        </div>
                                        {
                                            name &&
                                            <div className='flex items-center gap-x-2 mt-1'>
                                                {
                                                    image ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                                                            alt={`${'Profile'}`}
                                                            className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                                                        />
                                                    ) : (
                                                        <div style={{ backgroundColor: getColorForLabel(name?.charAt(0)) }}
                                                            className="w-5 h-5 rounded-full flex items-center justify-center">
                                                            <span className="font-medium text-white mt-[0px] leading-5"
                                                            >{name?.charAt(0) || task?.app_name?.charAt(0)}</span>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    name &&
                                                    <p className='text-[#1b1b1b]  overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize'>
                                                        {name || task?.app_name}
                                                    </p>
                                                }
                                                {
                                                    task?.app_headline &&
                                                    <div className='mx-[0px] w-[1px] h-[12px] bg-gray-400 block'></div>
                                                }
                                                {
                                                    task?.app_headline &&
                                                    <p className='text-[#1b1b1b]  overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize'>
                                                        {task?.app_headline}
                                                    </p>
                                                }
                                            </div>
                                        }

                                    </div>


                                    <div className='col-span-2 flex items-start gap-x-2'>



                                        <span className="text-sm text-gray-500">{formattedDate}</span>
                                    </div>



                                </div>
                            )
                        })
                    )}


                    {/* Pagination */}
                    {allTaskItem.hasNextPage && (
                        <div className="px-4 py-3 flex items-center justify-center">
                            <button
                                onClick={handleLoadMore}
                                disabled={isLoadingMore}
                                className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
                            >
                                {isLoadingMore ? (
                                    <span className="flex items-center gap-x-2">
                                        <div className="simple-spinner-load">
                                            <span></span>
                                        </div>
                                        Load More
                                    </span>
                                ) : (
                                    "Load More"
                                )}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div >
    )
}

export default JobActivity